module.exports = __webpack_public_path__ + "static/img/companyBackground.fa0ce9cc.png";